import { handleActions } from 'redux-actions';

import { actionTypes, PARTITION, ACTION_PREFIX } from './constants';
import { AccountIntent } from '../../types';
import { getActionOptions } from '../../lib/reduxActionsUtils';

export type ReduxState = {
  accountIntent: AccountIntent | any;
};

const initialState: ReduxState = {
  accountIntent: undefined,
};

const reducer = handleActions(
  {
    [actionTypes.GET_ACCOUNT_INTENT_FULLFILLED]: (state: any, { payload }) => ({
      ...state,
      accountIntent: payload.data,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducer,
};
